import {RouteConfig} from "vue-router";
const PathfinderView = () => import('../views/pathfinder/PathfinderView.vue');

let pathfinder: RouteConfig[] = [
    {
        name: 'pathfinder',
        path: '/pathfinder',
        component: PathfinderView,
        meta: {
            allowLoggedOut: true,
        },
    },
];

export default pathfinder;